import { GetterTree } from 'vuex';
import { State } from '@/manager/product/store/state';
import { Product, Branch } from '@/manager/product/models/product.model';

export interface Getters {
    getProductList: Product[];
}

export const getters: GetterTree<State, any> = {
    getProductList: (state) => state.list,
    getProductBudgetableList: (state) => {
        return state.list.filter((product: any) => {
            return product.isBudgetable;
        });
    },
    getProduct(state: State) {
        return (id: string) => {
            return state.list.find(
                (product: any) => {
                    return product.id === id;
                },
            );
        };
    },
    getProductBranch(state: State) {
        return (branch: Branch) => {
            if ( branch ) {
                return state.list.filter(
                    (product: any) => {
                        return product.formativeBranch === branch;
                    },
                ).sort(
                    (a: any, b: any) => {
                        return a.level - b.level;
                    },
                );
            } else {
                return state.list.filter(
                    (product: any) => {
                        return product.formativeBranch === null;
                    },
                ).sort(
                    (a: any, b: any) => {
                        if ( a.acronym && a.acronym.includes('TLP') ) {
                            return a.level - b.level;
                        } else {
                            return b.level - a.level;

                        }
                    },
                );
            }
        };
    },
};
